/** @jsxImportSource theme-ui */
import { Box, Heading } from 'theme-ui';
import { useParams } from 'react-router-dom';
import { JSONTree } from 'react-json-tree';
import { useGetVossUsageQuery } from '@/store/apiService';
import DataTable from '@/components/DataTable';
import jsonTreeTheme from '@/theme/jsonTreeTheme';

const columns = [
    {
        columnKey: 'id',
        Header: 'Id',
        accessor: 'id',
        width: '50px',
    },
    {
        columnKey: 'status',
        Header: 'Status',
        accessor: 'status',
        width: '50px',
    },
    {
        columnKey: 'idempotencyKey',
        Header: 'Idempotency Key',
        accessor: 'idempotencyKey',
    },
    {
        columnKey: 'quantity',
        Header: 'Quantity',
        accessor: 'quantity',
        width: '50px',
    },
    {
        columnKey: 'currentQuantity',
        Header: 'Current Quantity',
        accessor: 'currentQuantity',
        width: '50px',
    },
    {
        columnKey: 'customer, product, period',
        Header: 'Customer, Product, Period',
        accessor: (row: any) =>
            [
                ...Object.values(row.customer),
                // ...Object.values(row.period),
                // ...Object.values(row.product),
            ].join(','),
        Cell: ({ row, cell }) => {
            return (
                <Box
                    sx={{
                        '& > ul': {
                            padding: (t: any) => `${t.space[2]} !important`,
                            borderRadius: (t: any) => `${t.radii['sm']} !important`,
                        },
                    }}
                >
                    <Heading as="h3">Customer</Heading>
                    <JSONTree
                        data={row.original.customer}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />

                    <Heading as="h3">Period</Heading>
                    <JSONTree
                        data={row.original.period}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />

                    <Heading as="h3">Product</Heading>
                    <JSONTree
                        data={row.original.product}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />
                </Box>
            );
        },
    },
    {
        columnKey: 'created',
        Header: 'Created',
        accessor: 'created',
        width: '50px',
    },
];

const CompanyUsages = () => {
    const { id } = useParams();
    const usagesState = useGetVossUsageQuery({ CompanyId: id });
    const usages = usagesState.data?.CustomersUsage ? usagesState.data.CustomersUsage : [];

    return (
        <Box>
            <Heading>Company usages</Heading>
            <Box
                variant="segment"
                sx={{
                    borderRadius: 'sm',
                    overflowY: 'scroll',
                    zIndex: 2,
                    justifySelf: 'left',
                    width: '100%',
                    backgroundColor: 'background',
                    padding: 2,
                    position: 'relative',
                    table: {
                        display: 'block',
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                    },
                    thead: {
                        textAlign: 'center',
                    },
                }}
            >
                <DataTable
                    data={usages}
                    columns={columns}
                    isLoading={usagesState.isLoading}
                    isFetching={usagesState.isFetching}
                />
            </Box>
        </Box>
    );
};

export default CompanyUsages;
